// Three-dot sidebar menu button. Opens a shared dropdown via root state.
// The dropdown itself lives on the page level (ChatSidebarDropdown) to
// avoid parent opacity/overflow clipping issues.

export const SidebarItemMore = {
  tag: 'button',
  type: 'button',
  'aria-label': (el) => el.call('polyglot', 'workspace.sidebar.moreOptions'),
  text: '···',
  fontSize: 'A',
  fontWeight: '700',
  letterSpacing: '.1em',
  padding: '0 V',
  background: 'transparent',
  borderWidth: '0',
  color: 'caption',
  cursor: 'pointer',
  transition: 'opacity 120ms ease',
  flexShrink: '0',
  ':hover': { color: 'title' },

  onCreate: (el) => {
    if (!el.node) return
    el.node.style.opacity = '0'
    const row = el.node.closest('[data-sidebar-row]') || el.node.closest('[data-cid]')
    if (!row) return
    el._row = row
    el._onEnter = () => {
      if (el.node) el.node.style.opacity = '1'
    }
    el._onLeave = () => {
      if (!el.node) return
      // Don't hide if dropdown is open for this row
      const root = el.state?.root
      if (root?.contextDropdown?.open) return
      el.node.style.opacity = '0'
    }
    row.addEventListener('mouseenter', el._onEnter)
    row.addEventListener('mouseleave', el._onLeave)
  },

  onRemove: (el) => {
    if (el._row) {
      el._row.removeEventListener('mouseenter', el._onEnter)
      el._row.removeEventListener('mouseleave', el._onLeave)
    }
  },

  onClick: (e, el, s) => {
    e.stopPropagation()
    e.stopImmediatePropagation()
    e.preventDefault()
    const root = s?.root
    if (!root) return

    // Get the channel id from the row
    const row = el.node.closest('[data-cid]')
    const cid = row?.getAttribute('data-cid')

    // Teammate rows (ChatDMPersonRow) have no channel yet — only
    // `data-person-email` — so fall back to the person items/dispatch
    // instead of bailing out (the button rendered + hovered on these rows
    // but was inert because `cid` was always null).
    if (!cid) {
      const personRow = el.node.closest('[data-person-email]')
      const email = personRow?.getAttribute('data-person-email')
      if (!email) return

      const rect = el.node.getBoundingClientRect()
      const dd = root.contextDropdown
      if (dd?.open && dd?.personEmail === email) {
        root.update({ contextDropdown: null })
      } else {
        const items = el.call('personContextItems', root, email)
        root.update({
          contextDropdown: {
            open: true,
            x: rect.right,
            y: rect.bottom + 2,
            personEmail: email,
            items,
            actionFn: 'personContextDispatch',
            ...(el.dropdownZ ? { z: el.dropdownZ } : {})
          }
        })
      }
      return
    }

    const rect = el.node.getBoundingClientRect()

    // Toggle — close if already open for this row, open otherwise. Opens the
    // global shared ContextDropdown (same as the right-click menu) anchored
    // under the button, with the per-kind items from chatContextItems.
    const dd = root.contextDropdown
    if (dd?.open && dd?.channelId === cid) {
      root.update({ contextDropdown: null })
    } else {
      const items = el.call('chatContextItems', root, cid)
      root.update({
        contextDropdown: {
          open: true,
          x: rect.right,
          y: rect.bottom + 2,
          channelId: cid,
          items,
          actionFn: 'chatContextDispatch',
          ...(el.dropdownZ ? { z: el.dropdownZ } : {})
        }
      })
    }
  },

  // Items render into the global shared ContextDropdown.
  Dropdown: { display: 'none' }
}

export const SidebarItemMenuItem = {
  tag: 'button',
  type: 'button',
  padding: 'Z A',
  round: 'V',
  background: 'transparent',
  borderWidth: '0',
  cursor: 'pointer',
  fontSize: 'Z2',
  fontWeight: '500',
  textAlign: 'left',
  whiteSpace: 'nowrap',
  color: (el, s) => s.color || 'title',
  ':hover': { background: 'hover' },
  text: (el, s) => s.label || ''
}
